import { useCallback, useState } from 'react';
import ComparisonStatsBar from '../ComparisonStatsBar';
import { ChatComposerActions } from './ChatComposerActions';
import { ChatModelPicker } from './ChatModelPicker';
import { ChatPromptInput } from './ChatPromptInput';
import { ChatSearchResults } from './ChatSearchPanel';
import { ChatSearchToggle } from './ChatSearchToggle';

function ComposerModelHeader({ modelOptions, selectedModels, onToggleModel, searchMode, onToggleSearchMode }) {
  return (
    <ChatModelPicker
      options={modelOptions}
      selectedModels={selectedModels}
      onToggleModel={onToggleModel}
      rightSlot={<ChatSearchToggle searchMode={searchMode} onToggle={onToggleSearchMode} />}
    />
  );
}

function ChatComposerContent(props) {
  return (
    <>
      <ComposerModelHeader
        modelOptions={props.modelOptions}
        selectedModels={props.selectedModels}
        onToggleModel={props.onToggleModel}
        searchMode={props.searchMode}
        onToggleSearchMode={props.onToggleSearchMode}
      />
      <ChatPromptInput
        input={props.input}
        setInput={props.setInput}
        selectedKB={props.selectedKB}
        loading={props.loading}
        hasSelectedModel={props.hasSelectedModel}
        onSubmit={props.onSubmit}
        searchMode={props.searchMode}
        onSearchQueryChange={props.onSearchConversations}
      />
      <ChatSearchResults
        showSearchResults={props.searchMode && props.showSearchResults}
        filteredConversations={props.filteredConversations}
        onOpenConversation={props.onOpenConversation}
      />
      {!props.searchMode ? (
        <ChatComposerActions
          selectedKB={props.selectedKB}
          loading={props.loading}
          input={props.input}
          hasSelectedModel={props.hasSelectedModel}
        />
      ) : null}
    </>
  );
}

export function ChatComposer(props) {
  const hasSelectedModel = props.selectedModels.length > 0;
  const [searchMode, setSearchMode] = useState(false);
  const { onSearchConversations, setInput, input } = props;

  const handleToggleSearchMode = useCallback(
    (checked) => {
      setSearchMode(checked);
      if (checked) {
        onSearchConversations(input);
      } else {
        onSearchConversations('');
        setInput('');
      }
    },
    [input, onSearchConversations, setInput]
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    if (searchMode) {
      return;
    }
    props.onSubmit(event);
  };

  return (
    <form onSubmit={handleSubmit} className="mx-auto max-w-[1800px] space-y-3">
      <ComparisonStatsBar stats={props.preferenceStats} />
      <ChatComposerContent
        {...props}
        hasSelectedModel={hasSelectedModel}
        searchMode={searchMode}
        onToggleSearchMode={handleToggleSearchMode}
      />
    </form>
  );
}
